import {Injectable} from '@angular/core';
import {Events} from 'ionic-angular';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

export interface ISessionIdentity {
    userid: number;
    username: string;
    userrole: number;
    employeeid: number;
    authenticated: boolean;
    roles: string[]; 
}

@Injectable()
export class rsSessionSvc {
        // Define private variables for our class
    private mIdentity: ISessionIdentity = undefined;
    mAuthenticated: boolean = false; 

    constructor( private http: Http, private events: Events ) {
        
    }

    isIdentityResolved() : boolean {
        return( typeof this.mIdentity !== 'undefined');
    } 
    isAuthenticated(): boolean {
        return this.mAuthenticated;
    }
    isInRole( role: string ) : boolean {
        if( this.isAuthenticated() == false || this.isIdentityResolved() == false ) return false;
        return (this.mIdentity.roles.indexOf(role) != -1 );  
    }
    isInAnyRole(roles: string[] ) : boolean {
        if( this.isAuthenticated() == false || this.isIdentityResolved() == false ) return false;
        for( let roleIdx = 0; roleIdx < roles.length; roleIdx++ ) {
            if( this.isInRole(roles[roleIdx])) return true;
        }
        return false;
    }
    getIdentity() : ISessionIdentity {
        return this.mIdentity;
    }
    getUser() : string { 
        if( this.isAuthenticated() == false || this.isIdentityResolved() == false ) return 'Guest';
        return this.mIdentity.username;
    }
    getUserId() : number {
        if( this.isAuthenticated() == false || this.isIdentityResolved() == false ) return 0;
        return this.mIdentity.userid;
    }

    logout( localOnly : boolean = false ) : Observable<any> {
        return Observable.create( observer => {

            // First, let's unset our session identity
            this.mAuthenticated = false;
            this.mIdentity = undefined;
            observer.next();
            observer.complete();
        });
    }

    updateLastReport( reportid: number ) : Observable<any> {
        return Observable.create( observer => {
            let patchData = { 
                reportid: reportid
            };

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );

            this.http.patch( 'http://dfr.hydrocon.com/api/v1/users/' + this.getUserId() + '/report', body, options )
            .map( res => res.json() )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.err(err);
            }, () => {
                observer.complete();
            });
        });
    }
    changepw( password: string, newpass: string ) : Observable<any> {
        // Return our observable 
        return Observable.create( observer => {
            let postData = {
                username: this.getUser(),
                password: password,
                newpw: newpass
            };

            let body = JSON.stringify( postData );
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/changepw', body, options )
            .map( res => res.json() )
            .subscribe( result => {
                // Complete our operation 
                observer.next(result);
            }, err => { 
                // Handle our error events 
                observer.error(err.json());
            }, () => {
                // Handle our completion event
                observer.complete();
            });
        });
    }
    authenticate( username: string, password: string ) : Observable<any> {
        //Return our observable
        return Observable.create( observer => {
            let postData = { 
                username: username, 
                password: password
            };

            let body = JSON.stringify(postData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/login', body, options)
            .map( res => res.json() )
            .subscribe( result => {

                // Setup our identity structure
                this.mIdentity = <ISessionIdentity>{
                    userid: result.response.userid,
                    username: result.response.username,
                    authenticated: result.response.authenticated,
                    employeeid: result.response.employeeid,
                    userrole: result.response.userrole,
                    roles: [] // Roles get filled in afterward
                };

                console.log(this.isIdentityResolved());

                // Assign our roles 
                if( this.mIdentity.userrole == 1 ) this.mIdentity.roles.push('restricted');
                else if( this.mIdentity.userrole == 2 ) this.mIdentity.roles.push('standard');
                else if( this.mIdentity.userrole == 3 ) this.mIdentity.roles.push('manager');
                else if( this.mIdentity.userrole == 4 ) this.mIdentity.roles.push('admin');

                console.log('mIdentity: ' , this.mIdentity);

                // We are authenticated!
                this.mAuthenticated = true;

                this.events.publish('user:login', this.mIdentity.username );

                // Complete our operation 
                observer.next(result);
            }, err => { 
                // Handle our error events 
                observer.error(err.json());
            }, () => {
                // Handle our completion event
                observer.complete();
            });
        });        
    }   
}


// WEBPACK FOOTER //
// ./src/services/auth.service.ts